import {
    Button,
    Flex,
    Heading,
    Image,
    Stack,
    Text,
    useBreakpointValue,
} from '@chakra-ui/react';

import Lottie from '../lottie/Lottie'
import HeroImage from '../../assets/images/Hero-Image-Edited.jpg'
import { FaRegArrowAltCircleRight } from 'react-icons/fa';
  
    export default function Hero() {
    return (
      <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }} className="hero">
        <Flex p={8} flex={1} align={'center'} justify={'center'}>
          <Stack spacing={6} w={'full'} maxW={'lg'}>
            <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
              <Text
                className='text-focus-in'
                as={'span'}
                position={'relative'}
                fontSize='4xl'
                color={'brand.black'}
                _after={{
                  content: "''",
                  width: 'full',
                  height: useBreakpointValue({ base: '20%', md: '30%' }),
                  position: 'absolute',
                  bottom: 1,
                  left: 0,
                  bg: 'brand.main',
                  zIndex: -1,
                }}
                >
                Become an
              </Text>
              <br />{' '}
              <Lottie
                height='160px'
              />
            </Heading>
            <Text
                className="fade-in-2"
                fontSize={{ base: 'md', lg: 'lg' }}
                color={'brand.black'}
            >
              Create a safer and more inclusive workplace by empowering your team with ally.
            </Text>
            <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
                 <Button
                    rightIcon={<FaRegArrowAltCircleRight />}
                    as={'a'}
                    href={'/join'}
                    className="fade-in-3"
                    rounded={'full'}
                    bg={'brand.main'}
                    color={'white'}
                    _hover={{
                    bg: 'brand.dark',
                    }}
                >
                    Become an ally
                </Button>
                <Button
                    as={'a'}
                    href={'/learn'}
                    rounded={'full'}
                    className="fade-in-4"
                >
                    Learn More
                </Button>
            </Stack>
          </Stack>
        </Flex>
        <Flex flex={1} className="hero-image-wrapper">
          <Image
            className="slide-in-right"
            alt={'Login Image'}
            objectFit={'cover'}
            src={HeroImage}
          />
        </Flex>
      </Stack>
    );
  }